<!-- Created for ATLAS-532: Add Richtext editor -->
<template>
  <div v-show="!(field.hide && field.hide())" ref="textEditor">
    <md-field
      :key="name"
      :class="[
                { 'md-error': hasRequirements && isInvalid },
                { 'md-valid': hasRequirements && !isInvalid },
              ]"
    >
      <!-- View Mode -->
      <label>{{ field.label }}:</label>
      <div v-if="pageMode == 'view' || pageMode == 'assignee'" v-html="$vo[name].$model" v-linkified class="view-desc-style"></div>

      <!-- New/Edit Mode -->
      <TinyMceEditor
        v-if="pageMode != 'view' && pageMode !== 'assignee'"
        :content="$vo[name].$model"
        v-model="$vo[name].$model"
        :key="name"
        :name="name"
      />
      <md-icon v-if="hasRequirements && isInvalid">clear</md-icon>
      <md-icon v-else-if="hasRequirements && !isInvalid">done</md-icon>
      <span
        class="md-error"
        v-if="!isUnique"
      >{{ field.uniqueErrorMessage || 'This value is already in use.' }}</span>
    </md-field>
  </div>
</template>

<script>
import TinyMceEditor from "@/components/Editor/TinyMceEditor";

export default {
  name: "crud-texteditor",
  
  components: {
    TinyMceEditor
  },
  
  props: {
    field: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    pageMode: {
      type: String,
      required: true
    },
    form: {
      type: Object
    },
    $vo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  
  computed: {
    isInvalid: function() {
      let result = false,
        v = this.getV();
      if (v && Object.keys(v.$params).length && v.$invalid) result = true;
      return result;
    },
    hasRequirements: function() {
      let result = false,
        v = this.getV();
      if (v && Object.keys(v.$params).length) result = true;
      return result;
    },
    isUnique() {
      if (
        undefined == this.$vo[this.name].isUnique ||
        this.$vo[this.name].$pending
      ) {
        return true;
      }
      return this.$vo[this.name].isUnique;
    }
  },
  
  methods: {
    getV: function() {
      if (this.$vo && this.name && this.$vo[this.name] !== "undefined") {
        return this.$vo[this.name] || false;
      } else {
        return false;
      }
    },
    //new tab link
    openLinksInNewTab(e) {
      if ("a" == e.target.tagName.toLowerCase()) {
        e.target.setAttribute("target", "_blank");
      }
    }
  },
  /**
   * When link is copied and pasted in editor,
   * open it in new tab using mounted(), beforeDestroy()
   */
  mounted() {
    this.$refs.textEditor.addEventListener("click", this.openLinksInNewTab);
  },
  beforeDestroy() {
    this.$refs.textEditor.removeEventListener("click", this.openLinksInNewTab);
  }
};
</script>

<style lang="scss" scoped>
.md-field span.md-error {
  opacity: 1;
  color: #f44336 !important;
}
.md-field label {
  font-size: 12px;
}
</style>

<style>
.view-desc-style p {
  margin-top: 20px;
}
</style>
